// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Search_wrap__csMpa","form":"Search_form__IF16O","field":"Search_field__HjVt2","clear":"Search_clear__eYM31"};